import BaseModel from './BaseModel';
import User from './User';
import moment from 'moment';
import type { Moment } from 'moment';

export type QuoteTextTemplateKind = 'intro' | 'presentation' | 'conditions';

/** Global HTML template for quote intro, presentation or conditions. */
class QuoteTextTemplate extends BaseModel {
    static KIND_INTRO: QuoteTextTemplateKind = 'intro';
    static KIND_PRESENTATION: QuoteTextTemplateKind = 'presentation';
    static KIND_CONDITIONS: QuoteTextTemplateKind = 'conditions';

    _id: string;
    createdAt?: Moment;
    updatedAt?: Moment;
    name: string;
    kind: QuoteTextTemplateKind;
    body: string;
    isDefault: boolean;
    author?: User | string;

    constructor(properties: AnyObj = {}) {
        super({});

        this._id       = properties._id;
        this.createdAt = properties.createdAt ? moment(properties.createdAt) : undefined;
        this.updatedAt = properties.updatedAt ? moment(properties.updatedAt) : undefined;
        this.name      = properties.name || '';
        if (properties.kind === 'conditions')
            this.kind = 'conditions';
        else if (properties.kind === 'presentation')
            this.kind = 'presentation';
        else
            this.kind = 'intro';
        this.body      = properties.body || '';
        this.isDefault = !!properties.isDefault;
        this.author    = properties.author?._id
            ? new User(properties.author)
            : properties.author;
    }

    prepareForUpdate(): AnyObj {
        return {
            _id: this._id,
            name: this.name,
            kind: this.kind,
            body: this.body,
            isDefault: this.isDefault,
        };
    }
}

export default QuoteTextTemplate;
